"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeRules = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const ability_1 = require("@casl/ability");
const extra_1 = require("@casl/ability/extra");
const deserializeRules = (user) => {
    if (!user.serializedPermissions) {
        return (0, ability_1.createMongoAbility)();
    }
    const rules = (0, extra_1.unpackRules)(user.serializedPermissions);
    return (0, ability_1.createMongoAbility)(rules);
};
exports.deserializeRules = deserializeRules;
/**
 * Verify client authorization for a user
 *
 * @param {{ [key: string ]: string}} permissions An object with the permissions
 * to verify, the keys are the subject types and the values are the permissions
 * to authorize. For example, to get the method to validate if a user can 'read'
 * or 'update' subject of type 'Users', the permissions to send would be {Users:
 * ['read', 'update'] }
 */
const isAuthorized = (ability, permissions) => {
    // Check if the user has required permission, admin is a special case [for now]
    const permissionSubjects = Object.keys(permissions);
    for (let i = 0; i < permissionSubjects.length; i++) {
        const subject = permissionSubjects[i];
        const perms = typeof permissions[subject] === 'string'
            ? [permissions[subject]]
            : permissions[subject];
        const cant = perms.find((perm) => !ability.can(perm, subject));
        if (cant) {
            return false;
        }
    }
    return true;
};
exports.default = isAuthorized;
//# sourceMappingURL=authorization.js.map